import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './component/HeroSection';
import EducationalSupport from './component/EducationalSupport';
import ReadingThetor from './component/ReadingThetor';
import EducationalStaff from './component/EducationalStaff';
import DyslexiaService from './component/DyslexiaService';
import EducationalResources from './component/EducationalResources';
import EducationalTestimonials from './component/EducationalTestimonials';
import EducationalForm from './component/EducationalForm';
const EducationalPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Educational Services Wasilla Alaska | Guidepost Educational Support
        </title>
        <meta
          name="description"
          content="Educational services in Wasilla, Alaska for struggling readers, math learners, dyslexic students, and gifted children. Individualized plans and dynamic assessments to unlock your child's potential."
        />
        <meta
          name="keywords"
          content="educational services Wasilla, dyslexia testing Alaska, reading support Wasilla, educational support Alaska, tutoring services Wasilla"
        />
      </Helmet>
      <HeroSection />
      <EducationalSupport />
      <ReadingThetor />
      <EducationalStaff />
      <DyslexiaService />
      <EducationalResources />
      <EducationalTestimonials />
      <EducationalForm />
    </div>
  );
};

export default EducationalPage;
